<template>
    <dashboard v-if="team">
        <heading>
            <h1 slot="title">{{ team.name }}</h1>
            <template slot="buttons">
                <app-button 
                    v-if="!onDashboard"
                    plain
                    type="clear"
                    @click="addToDashboard">Add To Dashboard</app-button>
                <app-button 
                    v-else
                    plain
                    type="danger"
                    @click="removeFromDashboard">Remove From Dashboard</app-button>
                <app-button @click="showEditTeam = true">Edit Team</app-button>
            </template>
        </heading>
        <row>
            <link-list :routes="routes"/>
            <router-view :team="team"/>
        </row>

        <modal v-model="showEditTeam" size="small">
            <team-edit-view :team_id="team.id" />
        </modal>
    </dashboard>
</template>

<script>
import { mapGetters } from 'vuex'
import { get, comb } from '@/utilities'

import TeamEditView from './TeamEditView'
import Team from '@/store/models/Team'
import UserTile from '@/store/models/UserTile'

export default {
    name: 'page-teams-detail',
    components: {
        TeamEditView
    },
    props: ['uuid'],
    head: {
        title() {
            return {
                inner: comb('Team', '-', get(this, 'team.name'))
            }
        }
    },
    data() {
        return {
            showEditTeam: false
        }
    },
    computed: {
        ...mapGetters(['teamTiles']),
        team() { return Team.findUuid(this.uuid) },
        routes() {
            var routes = [
                {
                    title: 'Students',
                    name: 'teams.detail.students',
                    icon: 'icon-students'
                }
            ]
            if (this.team.is_sport) {
                routes.push({
                    title: 'Travel',
                    name: 'teams.detail.travel',
                    icon: 'icon-travel'
                })
            }
            routes.push({
                title: 'Users',
                name: 'teams.detail.users',
                icon: 'icon-users'
            })
            return routes
        },
        onDashboard() {
            return this.teamTiles
                .map((item) => item.id)
                .includes(this.team.id)
        }
    },
    mounted() {
        this.getTeam(this.uuid)
    },
    methods: {
        getTeam(uuid) {
            Team.$fetchOne({ uuid })
                .then(() => {
                    this.$emit('updateHead')
                })
        },
        addToDashboard() {
            UserTile.$mutate({
                graphql: 'addToDashboard',
                variables: {
                    tileable_id: this.team.id,
                    tileable_type: 'team'
                }
            }).finally(() => { location.reload() })
        },
        removeFromDashboard() {
            UserTile.$mutate({
                graphql: 'removeFromDashboard',
                variables: {
                    tileable_id: this.team.id,
                    tileable_type: 'team'
                }
            }).finally(() => { location.reload() })
        },
        navigateToStudentDetail(student) {
            this.$router.push({
                name: 'students.detail',
                params: { uuid: student.uuid }
            })
        }
    },
    watch: {
        uuid(newVal) {
            this.getTeam(newVal)
        }
    }
}
</script>

<style lang="stylus"></style>
